import { resolveAvatarUrl } from './api';

/**
 * Profil aus der API → Form, die ProfileCardV2 erwartet.
 *
 * Bis Oktober 2026 lebte das nur in hooks/useProfileLoader.js (Match-Liste).
 * Seitdem oeffnen auch Logbuch („Gelernt mit“) und Suche eine einzelne
 * Profilkarte (components/profile/ProfileSheet) und brauchen dieselbe Form.
 */
export const normalizeProfile = (profile = {}) => {
  const offeredSkills = profile.tenant_skills_OfferedSkills || profile.offeredSkills || profile.offers || [];
  const soughtSkills = profile.tenant_skills_SoughtSkills || profile.soughtSkills || profile.seeks || [];

  const normalizedOffers = Array.isArray(offeredSkills)
    ? offeredSkills.map(skill => (typeof skill === 'string' ? skill : skill.name || '')).filter(Boolean)
    : [];

  const normalizedSeeks = Array.isArray(soughtSkills)
    ? soughtSkills.map(skill => (typeof skill === 'string' ? skill : skill.name || '')).filter(Boolean)
    : [];

  return {
    ...profile,
    offeredSkills: normalizedOffers,
    soughtSkills: normalizedSeeks,
    offers: normalizedOffers,
    seeks: normalizedSeeks,
    name: profile.displayName || profile.name,
    bio: profile.bio || profile.aboutMe || '',
    aboutMe: profile.aboutMe || profile.bio || '',
    // WebP-Varianten statt Original: 'card' (384px) für die grosse Match-Karte,
    // 'thumb' (192px) für Listen - resolveAvatarUrl fällt bei Nicht-Avatar-Pfaden
    // (ui-avatars, data:) selbst auf resolveAssetUrl zurück
    image: resolveAvatarUrl(profile.image || profile.avatar || '', 'card'),
    avatar: resolveAvatarUrl(profile.avatar || profile.image || '', 'thumb'),
    matchScore: profile.matchScore || 0,
  };
};

export const normalizeProfiles = (profiles = []) =>
  (Array.isArray(profiles) ? profiles.map(normalizeProfile) : []);
